import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import api, { onMutation } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const StatsContext = createContext(null);

export function StatsProvider({ children }) {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);
  const reload = useCallback(async () => {
    try { setStats((await api.get("/dashboard/stats")).data); setUpdatedAt(Date.now()); } catch (e) { console.warn("Dashboardcijfers ophalen mislukt", e?.message); }
  }, []);
  useEffect(() => { if (user) reload(); }, [user, reload]);

  // Realtime aan de balie: elke 20 seconden verversen, en zodra het tabblad weer actief is
  useEffect(() => {
    if (!user) return;
    const id = setInterval(() => { if (!document.hidden) reload(); }, 20000);
    const onFocus = () => reload();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, [user, reload]);

  // Na elke geslaagde schrijfactie (check-in, demo-bezetting aanvullen, enz.) meteen
  // de cijfers verversen — gedebounced zodat een reeks wijzigingen één keer herlaadt.
  const debRef = useRef(null);
  useEffect(() => {
    if (!user) return;
    const off = onMutation(() => {
      clearTimeout(debRef.current);
      debRef.current = setTimeout(reload, 400);
    });
    return () => { off(); clearTimeout(debRef.current); };
  }, [user, reload]);
  return <StatsContext.Provider value={{ stats, reload, updatedAt }}>{children}</StatsContext.Provider>;
}

export function useStats() {
  return useContext(StatsContext);
}

// Bezetting telt enkel bruikbare plaatsen: geblokkeerde (buiten dienst) plaatsen tellen niet mee.
export const occupancyPct = (k) => {
  const base = (k?.total || 0) - (k?.buiten_dienst || 0);
  return base ? Math.round(((k.bezet + k.gereserveerd) / base) * 100) : 0;
};
export const occupancyColor = (pct) => (pct < 75 ? "#059669" : pct <= 90 ? "#f59e0b" : "#e11d48");
